import { loadLocale } from "@smart/itops-locale-dom";
import { CurrencyInput } from "@smart/itops-sb-design-system-dom";

import { FieldGroup } from "./field-group";
import { Label } from "./label";
import { FieldProps, FieldWrapper } from "./wrapper";
import { fieldName } from "../../hooks";

export const CurrencyField = ({
  field,
  index,
  innerRef,
  value,
  error,
  loading,
  disabled,
  onChange,
  onBlur,
}: FieldProps<HTMLInputElement>) => {
  const locale = loadLocale();
  const id = fieldName({ field, index });
  const errorId = fieldName({ field, index, suffix: "error" });

  return (
    <FieldWrapper disabled={disabled} isLoading={loading}>
      <FieldGroup
        id={id}
        hint={field.hint ?? undefined}
        label={<Label {...field} />}
        messageId={error ? errorId : undefined}
      >
        <CurrencyInput
          prefix={locale.currencySymbol}
          intlConfig={locale}
          ref={innerRef}
          id={id}
          name={id}
          error={!!error}
          message={error ?? undefined}
          aria-invalid={!!error}
          aria-errormessage={errorId ?? undefined}
          value={value?.value ?? ""}
          onValueChange={(_, name, values) => {
            onChange(values && values.float ? values : null);
          }}
          onBlur={onBlur}
        />
      </FieldGroup>
    </FieldWrapper>
  );
};
